import "./App.css";
import React from "react";
import Header from "./components/Header";
import NavBar from "./components/NavBar";
import About from "./components/About";
import Tech from "./components/Tech";
import Footer from "./components/Footer";

function App() {
  return (
    <div>
      <NavBar></NavBar>
      <Header></Header>
      <About></About>
      <Tech></Tech>
      <Footer></Footer>
    </div>
  );
}

export default App;
